import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { api } from "../../lib/chalkApi";
import { ChalkCard, DarkHeader, SectionTitle } from "../../components/chalk/primitives";
import { BackButton } from "./AdminBilling";

export default function AdminNotifications() {
  const navigate = useNavigate();
  const [data, setData] = useState({ sms: [], push: [], configured: {} });

  useEffect(() => {
    api.adminNotifications().then(setData);
  }, []);

  return (
    <>
      <DarkHeader eyebrow="Admin" title="Notification log" subtitle={data.configured?.twilio ? "Twilio: configured" : "Twilio: not configured (stub)"} right={<BackButton onClick={() => navigate(-1)} />} />
      <div style={{ padding: "0 18px 24px" }}>
        <SectionTitle label="Push (recent)" />
        {data.push.length === 0 ? <Muted>No pushes yet.</Muted> :
          data.push.map((p) => (
            <ChalkCard key={p.id} style={{ marginTop: 8 }} data-testid={`push-${p.id}`}>
              <Badge status={p.status} />
              <div style={{ fontSize: 13, color: "var(--chalk-board)", marginTop: 6 }}>{p.rendered_body}</div>
              <div style={{ fontSize: 11, color: "var(--chalk-muted)", marginTop: 4 }}>
                {p.trigger} · {p.created_at}
              </div>
            </ChalkCard>
          ))
        }

        <SectionTitle label="SMS" />
        {data.sms.length === 0 ? <Muted>No SMS yet.</Muted> :
          data.sms.map((s) => (
            <ChalkCard key={s.id} style={{ marginTop: 8 }}>
              <Badge status={s.status} />
              <div style={{ fontSize: 13, color: "var(--chalk-board)", marginTop: 6 }}>{s.rendered_body}</div>
            </ChalkCard>
          ))
        }
      </div>
    </>
  );
}

function Badge({ status }) {
  const map = {
    stub: { bg: "#FAEEDA", fg: "#B45309", label: "Stubbed" },
    sent: { bg: "#E1F5EE", fg: "#0F6E56", label: "Sent" },
    dropped_dup: { bg: "#F1EFE8", fg: "#5F5E5A", label: "Dropped (dup)" },
    dropped_pref: { bg: "#F1EFE8", fg: "#5F5E5A", label: "Dropped (pref)" },
    failed: { bg: "#FCEBEB", fg: "#A32D2D", label: "Failed" },
  };
  const m = map[status] || { bg: "#F1EFE8", fg: "#5F5E5A", label: status };
  return <span style={{ background: m.bg, color: m.fg, fontSize: 10, fontWeight: 500, padding: "2px 7px", borderRadius: 999 }}>{m.label}</span>;
}

function Muted({ children }) {
  return <div style={{ marginTop: 8, fontSize: 13, color: "var(--chalk-muted)" }}>{children}</div>;
}
